// Locale.js
// @flow
import * as d3 from 'd3';
import marked from 'marked'; //markdown npm -- https://www.npmjs.com/package/marked
import yaml from 'js-yaml';
import { state } from './State';

// ok -- loads en or es using loadMessages()
import enLocaleData from './translations/locales/en.json';
import esLocaleData from './translations/locales/es.json';

import helpers from './util/helpers';

// not ok
// import contentBase64 from './translations/locales/content_es.yaml';
// export const locale = 'es';
// new

if (helpers.findGetParameter('language')) {
  window.localStorage.setItem('language', helpers.findGetParameter('language'));
  window.localStorage.setItem('avatar', helpers.findGetParameter('avatar'));
}

// previously set languages in app
let possibleLocale;
let prevLang = window.localStorage.getItem('language')
if (prevLang) {possibleLocale = prevLang}

// if the language is not previously set, get browser languge
if (!possibleLocale) {
  let browserLang = navigator.language;
  // remove the country code part
  if (browserLang.includes("-")) {
    browserLang = browserLang.split("-")[0]
  }
  if (browserLang == "es" || browserLang == "en") {possibleLocale = browserLang}
}

// if the browser language is not spanish or english, default to english
if (!possibleLocale) {possibleLocale = "en"}

import enContentBase64 from './translations/locales/content_en.yaml'; // url-loader -- this will be something like "static/media/content_en.4b5383e7.yaml"
import esContentBase64 from './translations/locales/content_es.yaml'; // url-loader -- this will be something like "static/media/content_en.4b5383e7.yaml"

export const locale = possibleLocale;
export const GLOBAL_locale = possibleLocale; //XXX: allow setting with cookie

export default function loadMessages() {
  var cb64filename; // url-loader -- this will be something like "static/media/content_en.4b5383e7.yaml"
  if (GLOBAL_locale === 'en') cb64filename = enContentBase64;
  if (GLOBAL_locale === 'es') cb64filename = esContentBase64;
  return d3.text(cb64filename)
    .then((rawContent) => yaml.safeLoad(rawContent))
    .then((content) => {
      let localeData = GLOBAL_locale === 'en' ? enLocaleData : esLocaleData;
      Object.keys(content).forEach(function(key, index) {
        if(typeof(content[key]) == "string" && content[key].startsWith('!markdown')) {
          content[key] = content[key].replace(/PUBLIC_URL/g, process.env.PUBLIC_URL);
          content[key] = marked(content[key].replace('!markdown', ''));

          content[key] = content[key].replace(/href="http/g, 'target="_blank" href="http'); // external links open in new window/tab
        }

        localeData = Object.assign({}, localeData, content);
      });

      state.updateMessages(localeData);
    })
}



// WEBPACK FOOTER //
// ./src/Locale.js